/* eslint-disable @shopify/jsx-prefer-fragment-wrappers */
import {Theme} from 'utilities/color';

import styles from './LoadingPlaceholder.css';

interface Props {
  theme: Theme;
}

export function LoadingPlaceholder({theme}: Props) {
  return (
    <div
      className={[
        styles.loading__container,
        styles[`loading__container--${theme.toLowerCase()}`],
      ].join(' ')}
    >
      <div className={styles['loading__bar-container']}>
        <div className={[styles.loading__bar, styles['--one']].join(' ')} />
        <div className={[styles.loading__bar, styles['--two']].join(' ')} />
      </div>
      <div>
        <div className={[styles.loading__bar, styles['--logo']].join(' ')} />
      </div>
    </div>
  );
}
